import React from 'react';
import PropTypes from 'prop-types';

export default function DoNotSeeMyLocationAnswer({ query }) {
  const { getText } = Pollfish.ui;
  const noLocationText = getText('noLocation');
  return (
    <li className="country country--unknown">
      <ul className="country-codes ignore-collapse">
        <li
          className="country-code"
          data-postal-code-id={query}
          data-postal-code-country=""
          data-postal-code-place-id=""
          data-postal-code-prefer-not-to-say=""
        >
          {noLocationText}
        </li>
      </ul>
    </li>
  );
}

DoNotSeeMyLocationAnswer.propTypes = {
  query: PropTypes.string.isRequired,
};
